import { render, staticRenderFns } from "./creditCourtDecisionDetail.vue?vue&type=template&id=5380866e&scoped=true"
import script from "./creditCourtDecisionDetail.vue?vue&type=script&lang=js"
export * from "./creditCourtDecisionDetail.vue?vue&type=script&lang=js"
import style0 from "./creditCourtDecisionDetail.vue?vue&type=style&index=0&id=5380866e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5380866e",
  null
  
)

export default component.exports